import { Tooltip } from 'antd';
import { VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { useInstallMeterStepsStore } from '../../components/store';
import { useStore } from '../../useStore';
import { selectIsInstallMeterDetailStepOK } from '../sensor_scan/selectors';
import { InstallMeterDetailStepFooter as messages } from './messages';

export const InstallMeterDetailStepFooter: VFC = () => {
  const { setPreviousStep } = useInstallMeterStepsStore();
  const isStepOK = useStore(selectIsInstallMeterDetailStepOK);
  const intl = useIntl();

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>

      <Tooltip placement="top" title={!isStepOK ? intl.formatMessage(messages.tooltip) : null}>
        <Button
          key="submit"
          block
          disabled={!isStepOK}
          form="installMeterDetailStepForm"
          htmlType="submit"
          type="primary"
        >
          <FormattedMessage {...messages.next} />
        </Button>
      </Tooltip>
    </>
  );
};
